function AddressContactItem(props) {
  const { item } = props;
  return (
    <address className="flex flex-col w-full gap-2 relative max-w-xs">
      <h3 className="font-bold uppercase text-gray-700">{item.title}</h3>
      <a
        href={item.googleMapsLink}
        target="_blank"
        rel="noreferrer"
        className="text-gray-500 underline decoration-gray-200 transition-colors hover:text-red-main"
      >
        {item.address}
      </a>
    </address>
  );
}

export default AddressContactItem;
